import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

/**
 * React Router v6 compatibility: provides location, navigate, match.params to class components.
 * Use like: export default withRouter(MyComponent)
 */
export function withRouter(Component) {
  function Wrapper(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const match = { params };
    return (
      <Component
        {...props}
        location={location}
        navigate={navigate}
        match={match}
      />
    );
  }
  Wrapper.displayName = 'WithRouter(' + (Component.displayName || Component.name || 'Component') + ')';
  return Wrapper;
}
